import { render } from "./ResourceModules.vue?vue&type=template&id=21d37869"
import script from "./ResourceModules.vue?vue&type=script&lang=js"
export * from "./ResourceModules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__